class UserGroupsApi {
  constructor(client, url) {
    this.url = url
    this.client = client
  }
  customersNotAssociates(companyId, companyGroupId, params) {
    return this.client
      .get(`/admin/v1/companies/${companyId}/company-groups/${companyGroupId}/customers-not-associated`, {
        params,
      })
      .then((response) => response.data)
  }
  customersAssociates(companyId, companyGroupId, params) {
    return this.client
      .get(`/admin/v1/companies/${companyId}/company-groups/${companyGroupId}/customers-associated`, { params })
      .then((response) => response.data)
  }
  removeUserFromGroup(hash) {
    return this.client
      .put(`/admin/v1/customers/${hash}/change-to-default-company-group`)
      .then((response) => response.data)
  }
  getCompanySpecialities(companyId) {
    return this.client
      .get(`/admin/v1/companies/${companyId}/company-groups/specialities`)
      .then((response) => response.data)
  }

  indexUpdated(params, filters) {
    return this.client
      .get(`${this.url}${filters ? '?' + new URLSearchParams(filters).toString() : null}`, { params })
      .then((response) => response.data)
  }

  search(ids, params) {
    return this.client.get(`${this.url}/${ids}`, { params }).then((response) => response.data)
  }

  index(params) {
    return this.client.get(this.url, { params }).then((response) => response.data)
  }

  show(id) {
    return this.client.get(`${this.url}/${id}`).then((response) => response.data)
  }

  store(data) {
    return this.client.post(this.url, data).then((response) => response.data)
  }

  update(id, data) {
    return this.client.put(`${this.url}/${id}`, data).then((response) => response.data)
  }

  delete(id) {
    return this.client.delete(`${this.url}/${id}`).then((response) => response.data)
  }
}

export default UserGroupsApi
